import ReactModal from "react-modal";

interface CVVInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const CVVInfoModal: React.FC<CVVInfoModalProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="CVV Information"
      className="modal"
      overlayClassName="overlay"
    >
      <div className="text-center">
        <p>
          It's a three or four digit number, usually located on the signature
          panel on the back of most credit cards.
        </p>
      </div>
    </ReactModal>
  );
};

export default CVVInfoModal;
